// src/api/customer.js
import { customerApi } from "../utils/apiConfig";

export const setRole = (data, token) =>
  customerApi.post("/setRole", data, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const updateRole = (data, token) =>
  customerApi.post("/updateRole", data, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getRoles = (token) =>
  customerApi.get("/getRole", {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getPermissions = (token) =>
  customerApi.get("/getPermissions", {
    headers: { Authorization: `Bearer ${token}` }
  });
